import axios from 'axios'

export default {
  list (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/grouppermission', { params: opts })
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  created (context, opts) {
    if (opts) {
      axios
        .get('/api/grouppermission', { params: { group: opts } })
        .then(({ data }) => {
          context.commit('LIST', data)
        }).catch((error) => console.log(error))
    }
  },
  destroyed (context, opts) {
    if (opts) {
      axios
        .get('/api/grouppermission', { params: { group: opts } })
        .then(({ data }) => {
          context.commit('LIST', data)
        }).catch((error) => console.log(error))
    }
  },
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/grouppermission', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  remove (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/grouppermission', { data: opts })
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
